import { createContext, useState } from "react";
import { BookingType } from "../services/types";
import { BookingContextType } from "./types";

const defaultValues = {
  booking: {},
  setBooking: () => {},
  organization: { id: "", name: "", nameUrl: "" },
  setOrganization: () => {},
  removeLocalStorageValues: () => {},
};

export const BookingContext = createContext<BookingContextType>(defaultValues);

// provider for booking:
// booking and organization are stored in local storage and as global states
// if refresh the page, the booking and organization are not lost
const BookingProvider = ({ children }) => {
  // get initial values from local storage (if any)
  const getInitialSettingsValues = (name) => {
    // load from local storage
    const saved = localStorage.getItem(name);
    const initialValue = saved !== "undefined" ? JSON.parse(saved) : undefined;
    return initialValue || {};
  };

  // set initial state
  const initialBookingState = getInitialSettingsValues("booking");
  const [booking, setStateBooking] = useState<BookingType>(initialBookingState);

  // to get organization
  const initialOrganizationState = getInitialSettingsValues("organization");
  const [organization, setStateOrganization] = useState(
    initialOrganizationState
  );

  // update booking
  const setBooking = (booking) => {
    // update state
    setStateBooking(booking);

    // udpate local storage
    localStorage.setItem("booking", JSON.stringify(booking));
  };

  // update organization
  const setOrganization = (organization) => {
    // update state
    setStateOrganization(organization);

    // udpate local storage
    localStorage.setItem("organization", JSON.stringify(organization));
  };

  // remove local storage variable
  const removeLocalStorageValues = () => {
    localStorage.removeItem("booking");
    localStorage.removeItem("organization");
  };

  return (
    <BookingContext.Provider
      value={{
        booking,
        setBooking,
        organization,
        setOrganization,
        removeLocalStorageValues,
      }}
    >
      {children}
    </BookingContext.Provider>
  );
};

export default BookingProvider;
